import { TransportCostSource } from 'api';

export const displayTransportCostSource = (source: TransportCostSource) => {
  switch (source) {
    case TransportCostSource.XENETA:
      return 'Xeneta API';
    case TransportCostSource.HISTORICAL_QUOTES:
      return 'Historical Quotes';
    case TransportCostSource.LONG_SHORT_PRICE:
      return 'Long Short Price';
    case TransportCostSource.EXTERNAL_SOURCE_AVERAGES:
      return 'External Source Averages Collected by Michael';
    case TransportCostSource.QUOTES_BASED_AVERAGES:
      return 'Historical Averages Based on Logged Quotes';
    case TransportCostSource.FIRM_QUOTE:
      return 'Firm Quote';
    case TransportCostSource.DIRECT_LAND_ESTIMATE:
      return 'Direct Land per km Estimate';
  }
};
